import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { IInfoCenterReport, IInfoCenterReports } from 'types/info-center/reports'
import { IPaginationQueryInfo } from 'types/pagination'

export const infoCenterReportsApi = createApi({
  reducerPath: 'infoCenterReports',
  baseQuery,
  tagTypes: ['Reports'],
  endpoints: (builder) => ({
    reports: builder.query<IInfoCenterReports, IPaginationQueryInfo>({
      query: (params) => {
        return {
          url: '/info-center/report',
          method: 'get',
          params,
        }
      },
      providesTags: ['Reports'],
    }),
    deleteReport: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/info-center/report/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Reports'],
    }),

    createReport: builder.mutation<void, Partial<IInfoCenterReport>>({
      query: (body) => ({
        url: `/info-center/report`,
        body,
        method: 'post',
      }),
      invalidatesTags: ['Reports'],
    }),
  }),
})

export const { useReportsQuery, useCreateReportMutation, useDeleteReportMutation } =
  infoCenterReportsApi
